import { render, staticRenderFns } from "./pre_exam.vue?vue&type=template&id=e6ef9bca&scoped=true&"
import script from "./pre_exam.vue?vue&type=script&lang=js&"
export * from "./pre_exam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ef9bca",
  null
  
)

export default component.exports